<template>
  <div class="texto-wrapper mt-4">
    <h6 class="font-weight-bold">
      Efetividade da coleta do exame citopatológico do colo do útero (exame Papanicolau)
    </h6>
    <p>
      Como visto no texto, é possível verificar se a quantidade anual de pacientes que fazem a
      coleta do exame citopatológico do colo do útero em um determinado município está dentro da
      meta esperada para diminuir o número de casos novos desse tipo de câncer.
    </p>
    <p>
      Além disso, é possível verificar se a coleta está sendo realizada adequada e efetivamente, de
      forma que o exame coletado tenha boa qualidade diagnóstica.
    </p>
    <p>
      A maioria dos cânceres de colo de útero e das lesões pré-malignas ocorre numa região do colo
      chamada de junção escamo colunar (JEC), que fica na parte final do canal que liga o interior
      do útero com o colo do útero. Como essa região possui células características que só ocorrem
      nela, o patologista – profissional que avalia, usando um microscópio, o exame coletado – pode
      afirmar que, caso essas células não estejam visíveis, o exame não tem boa qualidade
      diagnóstica.
    </p>
    <p>
      Para avaliar se um município atingiu ou não a meta de efetividade, utilizam-se os seguintes
      parâmetros:
    </p>
    <ul>
      <li>
        Menos de 40% de efetividade = <span class="meta meta--ruim">MUITO ABAIXO DA META</span>
      </li>
      <li>
        Entre 40% e 79% de efetividade = <span class="meta meta--medio">ABAIXO DA META</span>
      </li>
      <li>
        80% ou mais de efetividade = <span class="meta meta--boa">META ATINGIDA</span>
      </li>
    </ul>
    <p>
      Para cada uma dessas situações, são fornecidos planos de ação para auxiliar o gestor municipal
      a manter ou atingir as metas de efetividade da coleta.
    </p>
    <h6 class="font-weight-bold">Como o indicador é produzido</h6>
    <p>
      Os Sistemas de Informação em Saúde (SIS) governamentais, sem identificar nenhuma paciente e,
      portanto, preservando a privacidade e a intimidade e respeitando a Lei Geral de Proteção de
      dados (LGPD), fornecem a informação tanto de quantas pacientes tiveram o exame coletado nas
      unidades públicas de saúde de cada município, como de quantos exames tiveram a JEC detectada
      pelo patologista.
    </p>
    <p>
      Essa informação é disponibilizada de forma pública pelo Departamento de Informática do SUS
      (DATASUS) no site do TABNET-SUS.
    </p>
    <p>
      Com isso, é possível determinar qual foi o percentual de pacientes avaliadas em que a coleta
      foi efetiva, ou seja, o quanto da cobertura de exames realmente produziu exames úteis para o
      rastreamento do câncer de colo uterino, por meio da seguinte fórmula de cálculo:
    </p>
    <div class="border border-dark text-center mb-3">
      <p class="small-text mt-2 mb-2">
        <b>Efetividade da cobertura anual</b> = exames com JEC presente / pacientes examinadas x 100
      </p>
    </div>
    <p>
      Todos os dados utilizados na construção desse indicador são públicos e estão disponíveis nos
      sites das instituições citadas no texto. Na Nota Técnica estão disponíveis os passos que
      permitem a reprodução da extração dos dados, bem como o resultado desta extração, os
      Microdados utilizados na construção deste site.
    </p>
    <p>Referências</p>
    <p>
      1. Brasil. Ministério da Saúde. Instituto Nacional de Câncer José Alencar Gomes da Silva
      (INCA). Diretrizes brasileiras para o rastreamento do câncer do colo do útero. 2. ed. rev.
      ampl. atual. Rio de Janeiro: INCA, 2016:114p. Disponível em:
      <a class="word-break-all" :href="urlReferencias1" target="_blank">{{ urlReferencias1 }}</a>
    </p>
    <p>
      2. Brasil. Ministério da Saúde. Instituto Nacional de Câncer José Alencar Gomes da Silva
      (INCA). Parâmetros técnicos para o rastreamento do câncer do colo do útero. Org; Dias MB,
      Ribeiro, CM. Rio de Janeiro. 2019:32p. Disponível em:
      <a class="word-break-all" :href="urlReferencias2" target="_blank">{{ urlReferencias2 }}</a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'texto-explicativo-efetividade-coleta',
  props: {},
  data: () => ({
    urlReferencias1: 'https://www.inca.gov.br/sites/ufu.sti.inca.local/files//media/document//diretrizesparaorastreamentodocancerdocolodoutero_2016_corrigido.pdf',
    urlReferencias2: 'https://www.inca.gov.br/sites/ufu.sti.inca.local/files//media/document//parametros_tecnicos_colo_do_utero_2019.pdf',
  }),
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
a {
  font-weight: bold;
}

.word-break-all {
  word-break: break-all;
}

.meta {
  font-weight: bold;

  &--boa {
    color: #0AB87F;
  }

  &--medio {
    color: #F8950E;
  }

  &--ruim {
    color: #D53C3C;
  }
}

.small-text {
  font-size: .875rem
}
</style>
